export interface BatchSchoolStatisticsReadNewStudentCsvFileRequest {
  grantUserId: boolean
  startNumberingUserId: string
  fileName: string
}

export function BatchSchoolStatisticsReadNewStudentCsvFileRequestToJSON(
  value: BatchSchoolStatisticsReadNewStudentCsvFileRequest
): any {
  return {
    grant_user_id: value.grantUserId ?? undefined,
    start_numbering_user_id:
      value.startNumberingUserId !== ''
        ? value.startNumberingUserId
        : undefined,
    file_name: value.fileName !== '' ? value.fileName : undefined
  }
}
